import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const keyPrefix = 'detach_department_groups';
export const useDetachDepartmentGroupsTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => {
  return useTranslation('features', { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Открепить группу от подразделения',
    toast_success: 'Группа успешно откреплена от подразделения',
    toast_error: 'Не удалось открепить группу от подразделения',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Detach group from department',
    toast_success: 'Group successfully detached from department',
    toast_error: 'Failed to detach group from department',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Desvincular grupo del departamento',
    toast_success: 'Grupo desvinculado del departamento correctamente',
    toast_error: 'No se pudo desvincular el grupo del departamento',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Desvincular grupo do departamento',
    toast_success: 'Grupo desvinculado do departamento com sucesso',
    toast_error: 'Não foi possível desvincular o grupo do departamento',
  },
}) : {}) as Record<string, unknown>;
